const DARK_INK = '#333f52';
const LIGHT_INK = '#fff';
const CONTRAST_THRESHOLD = 0.45;
const FALLBACK_CHANNELS: [number, number, number] = [128, 128, 128];

/**
 * Ink for text sitting on the accent colour. The light theme paints the footer in a community's
 * own branding, so a pale accent would otherwise leave white text on a near-white footer.
 */
export function onAccent(accent: string): string {
  const rgb = parseHex(accent);

  return !rgb || luminance(rgb) > CONTRAST_THRESHOLD ? DARK_INK : LIGHT_INK;
}

/** Channels for the alpha washes the light theme lays over the accent, which rgba() needs split. */
export function accentChannels(accent: string): string {
  return (parseHex(accent) ?? FALLBACK_CHANNELS).join(', ');
}

function parseHex(color: string): [number, number, number] | undefined {
  const hex = /^#([0-9a-f]{3,8})$/i.exec(color?.trim() ?? '')?.[1];

  if (!hex || (hex.length !== 3 && hex.length !== 4 && hex.length !== 6 && hex.length !== 8)) {
    return undefined;
  }

  const full = hex.length <= 4 ? [...hex].map(char => char + char).join('') : hex;

  return [0, 2, 4].map(index => parseInt(full.slice(index, index + 2), 16)) as [number, number, number];
}

function luminance([red, green, blue]: [number, number, number]): number {
  const [r, g, b] = [red, green, blue].map(channel => {
    const value = channel / 255;

    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
